import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import headerImage from '../images/ic-results.png';

class RegistrationTitleCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <div className="regCards">
                <div class="form-group required">
                    <h5><div class="addIcon"><img src={headerImage} width="25" /></div>{this.props.strings.DEPENDENT_BOX_HEADER}</h5>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        user: state.api.user,
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
    }
}

const ConnectedRegTitleCard = connect(
    mapStateToProps
)(RegistrationTitleCard);

export default withRouter(ConnectedRegTitleCard);
